import { ReactNode } from 'react'
import { ApolloProvider } from '@apollo/client'
import { StyledEngineProvider, ThemeProvider } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { Bugsnag as BugsnagProvider } from 'components/Analytics'
import { client } from 'config/apollo/client'
import bugsnagClient from 'config/bugsnag'
import { AuthProvider, UnleashProvider } from 'context'
import { getVideoCallsFlowCustomizationParams } from 'hooks/useVideoCallsFlowCustomization'
import { ConfirmProvider } from 'material-ui-confirm'
import { PARTNER_ID_KEY } from 'screens/VideoCalls/utils/constants'
import { isKeggWebviewFlow } from 'utils/keggWebviewFlow'
import { useLocalStorage } from 'utils/localStorage'
import { theme as keggTheme } from '../theme/kegg'
import { theme as nutrisenseTheme } from '../theme/nutrisense'
import type { Client } from '@bugsnag/js'

export const Providers = ({ children }: { children: ReactNode }) => {
  const [partner] = useLocalStorage(PARTNER_ID_KEY)

  let theme = nutrisenseTheme

  if (isKeggWebviewFlow(partner, getVideoCallsFlowCustomizationParams().forceKeggFlow)) {
    theme = keggTheme
  }

  return (
    <ApolloProvider client={client}>
      <BugsnagProvider client={bugsnagClient as unknown as Client}>
        <UnleashProvider>
          <AuthProvider>
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={theme}>
                <ConfirmProvider>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    {children}
                  </LocalizationProvider>
                </ConfirmProvider>
              </ThemeProvider>
            </StyledEngineProvider>
          </AuthProvider>
        </UnleashProvider>
      </BugsnagProvider>
    </ApolloProvider>
  )
}
